import React from "react";
import { Typography } from "antd";
import "./profileOverview.css";

/**
 * Optional inner grouping inside an info card (subsection title + body).
 */
const ProfileSection = ({ title, description, children, className }) => {
  if (!children) return null;

  return (
    <div className={`profile-overview-inner-section ${className || ""}`}>
      {title && (
        <Typography.Text className="profile-overview-inner-section-title">
          {title}
        </Typography.Text>
      )}
      {description && (
        <Typography.Paragraph type="secondary" style={{ marginBottom: 8 }}>
          {description}
        </Typography.Paragraph>
      )}
      <div className="profile-overview-inner-section-body">{children}</div>
    </div>
  );
};

export default ProfileSection;
